const mapBlock = (() => {

    const initBlock = (el) => {
        handleCurrentLocation(el);
        handleSearch(el);
    };
    
    const handleCurrentLocation = el => {
        const wrapper = el.querySelector('.map-search');
        const currentLocation = wrapper.querySelector('[data-current-location]');
        const location = wrapper.querySelector('input[name="preferred-location"]');
        const reset = () => {
            currentLocation.innerHTML = 'Use current location';
            currentLocation.dataset.currentLocation = '';
            location.value = '';
            location.removeAttribute('disabled');            
        }
        currentLocation.addEventListener('click', () => {
            if (currentLocation.dataset.currentLocation === ''){
                navigator.geolocation.getCurrentPosition(position => {
                    currentLocation.dataset.currentLocation = `${position.coords.latitude},${position.coords.longitude}`;
                    location.value = 'Current Location';
                    location.setAttribute('disabled','');
                    currentLocation.innerHTML = 'Clear';
                }, () => reset());       
            } else {
                reset();
            }
        });
    };
    
    const handleSearch = el => {
        const wrapper = el.querySelector('.map-search');
        const searchButton = wrapper.querySelector('button[type="submit"]');        
        searchButton.addEventListener('click', () => {
            const currentLocation = wrapper.querySelector('[data-current-location]');
            const location = wrapper.querySelector('input[name="preferred-location"]');
            const radius = wrapper.querySelector('select[name="search-radius"]');
            const isCurrentLocation = location.value === 'Current Location'
            const locationValue = isCurrentLocation
                ? currentLocation.dataset.currentLocation 
                : location.value;
            const radiusValue = radius.value;
            
            const locationsList = el.querySelector('[data-locations]');
            const locationsListValue = locationsList.dataset.locations;
            
            if (locationValue !== ''){
                location.classList.remove('input-validation-error');
                fetch(`/Umbraco/management/api/Locations/GetLocationsSearch?location=${locationValue}&radius=${radiusValue}&isCurrentLocation=${isCurrentLocation}&locationsList=${locationsListValue}`)
                    .then(response => response.json()
                        .then(data => {
                            const mapWrapper = el.querySelector('.map-block__map');
                            if (mapWrapper){
                                const innerHTML = data.locations.length 
                                    ? `<div class="map" data-map></div><script>function mapCallback(){}</script><script defer src=""></script>`
                                    : `<div class=\"text-content text-content--alt text-content--center\"><h2 class=\"title set-h2\">Sorry, we couldn't find any results matching your filters</h2><div class=\"text-content__content cms\"><p>Please try changing your filters and search again.</p></div></div>`;
                                mapWrapper.innerHTML = innerHTML;
                                if (!data.locations.length) {
                                    return;
                                }
                                const map = el.querySelector('[data-map]');
                                const options = {
                                    locations: data
                                }
                                new GoogleMap(map, options)
                            }
                        }));                
            }else{
                location.classList.add('input-validation-error');
            }
            
        });        
    };
    return {initBlock};

})();

ControlBinders.register(`.map-block`, el => mapBlock.initBlock(el));